import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, BaseRequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { ApplicationArtatech } from './application-artatech.model';
import { DateUtils } from 'ng-jhipster';
@Injectable()
export class ApplicationArtatechService {

    private resourceUrl = 'api/applications';
    private resourceSearchUrl = 'api/_search/applications';

    constructor(private http: Http, private dateUtils: DateUtils) { }

    create(application: ApplicationArtatech): Observable<ApplicationArtatech> {
        let copy: ApplicationArtatech = Object.assign({}, application);
        copy.lastModificationDate = this.dateUtils.toDate(application.lastModificationDate);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(application: ApplicationArtatech): Observable<ApplicationArtatech> {
        let copy: ApplicationArtatech = Object.assign({}, application);

        copy.lastModificationDate = this.dateUtils.toDate(application.lastModificationDate);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<ApplicationArtatech> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            let jsonResponse = res.json();
            jsonResponse.lastModificationDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.lastModificationDate);
            return jsonResponse;
        });
    }

    findAll(): Observable<Response> {
        let options = this.createRequestOption();
        return this.http.get(this.resourceUrl+'/all', options)
            .map((res: any) => this.convertResponse(res))
        ;
    }

    query(req?: any): Observable<Response> {
        let options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }


    findLocalFiles(): Observable<Response> {
        let options = this.createRequestOption();
        return this.http.get(this.resourceUrl+'/local', options)
        ;
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    search(req?: any): Observable<Response> {
        let options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }

    private convertResponse(res: any): any {
        let jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].lastModificationDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].lastModificationDate);
        }
        res._body = jsonResponse;
        return res;
    }

    private createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/application/application-artatech.service.ts